/* =========================================================
   Salty Good 4-Pack Landing Page — Commerce bindings
   All add-to-cart forms use real Shopify /cart/add.js AJAX.
   In the standalone preview (outside Shopify), this endpoint
   will 404 — that is expected. Inside the ported Liquid theme,
   the variant input is populated by the section schema/product
   object, and /cart/add.js resolves against the real store.
   ========================================================= */

(function () {
  'use strict';

  var toastEl = document.getElementById('cartToast');
  var stickyBar = document.getElementById('stickyBar');
  var heroSection = document.getElementById('hero');

  function showToast(message, isError) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.toggle('sg-toast--error', !!isError);
    toastEl.classList.add('is-visible');
    window.clearTimeout(toastEl._timer);
    toastEl._timer = window.setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 3200);
  }

  function updateCartCount(count) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count } }));
  }

  function bindAtcForm(form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var button = form.querySelector('[data-atc-button]');
      var label = form.querySelector('[data-atc-label]');
      var originalLabel = label ? label.textContent : '';
      var formData = new FormData(form);

      if (button) button.disabled = true;
      if (label) label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error((err && err.description) || 'Could not add to cart');
            });
          }
          return res.json();
        })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('cart:add', {
            detail: { id: item.variant_id, quantity: item.quantity }
          }));
          showToast('Added to cart — Salty Good 4-Pack ×' + item.quantity);
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (cart) updateCartCount(cart.item_count);
        })
        .catch(function (err) {
          showToast(err.message || 'Something went wrong — try again', true);
        })
        .finally(function () {
          if (button) button.disabled = false;
          if (label) label.textContent = originalLabel;
        });
    });
  }

  document.querySelectorAll('[data-atc-form]').forEach(bindAtcForm);

  /* Sticky mobile buy bar: show once hero has scrolled past */
  if (stickyBar && heroSection && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(heroSection);
  }
})();
